import { Pipe, PipeTransform, effect, inject } from '@angular/core';
import { FeatureFlagsService } from '../services/feature-flags/feature-flags.service';
import { USER } from '@tokens/user.token';
import { MenuUrl } from '@type/menu.type';

@Pipe({
  name: 'menuPermissions',
  standalone: true,
  pure: false,
})
export class MenuPermissionsPipe implements PipeTransform {
  private user = inject(USER);
  private featureFlags = inject(FeatureFlagsService);

  private static routes: string[] = ['', 'companies'];

  constructor() {
    effect(() => {
      const { superUserRole } = this.user();

      MenuPermissionsPipe.routes = ['', 'companies', 'log'];

      !superUserRole && MenuPermissionsPipe.routes.push('application-admins');
    });
  }

  transform(value: MenuUrl[], routes?: string[]): MenuUrl[] {
    const allowed = routes ?? MenuPermissionsPipe.routes;
    const withFlags = this.featureFlags.isEnabled('analytics')
      ? [...allowed, 'analytics']
      : allowed;
    return value.filter(({ name }) => withFlags.includes(name));
  }
}
